import { render, staticRenderFns } from "./vehicleLogisticsMonitoringBd.vue?vue&type=template&id=ddedb6be"
import script from "./vehicleLogisticsMonitoringBd.vue?vue&type=script&lang=js"
export * from "./vehicleLogisticsMonitoringBd.vue?vue&type=script&lang=js"
import style0 from "./vehicleLogisticsMonitoringBd.vue?vue&type=style&index=0&id=ddedb6be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports